/* Fulfillment date/time picker — for all flower products (first in cart).
   Flow: Pickup/Delivery radios → Date → Time (wheel for pickup, 2hr windows for delivery).
   Rules (America/Chicago / Dallas time):
   - Ready-nextday: ALWAYS at least tomorrow. Sat after 10 AM → Monday (skip Sunday).
   - Other: today if enough prep time before close, else tomorrow.
   - We're OPEN Sundays. */
(function () {
  var picker = document.querySelector('[data-fulfill-picker]');
  if (!picker) return;
  var dateInput = picker.querySelector('[data-fulfill-date]');
  var hint = picker.querySelector('[data-fulfill-hint]');
  if (!dateInput) return;

  var isNextDay = picker.getAttribute('data-next-day') === '1';
  var leadDays = parseInt(picker.getAttribute('data-lead-days') || '0', 10);
  if (leadDays >= 1) isNextDay = true;
  var prepMin = parseInt(picker.getAttribute('data-prep-minutes') || '60', 10);

  var pickupWrap = picker.querySelector('[data-pickup-time]');
  var deliveryWrap = picker.querySelector('[data-delivery-time]');
  var deliverySelect = picker.querySelector('[data-delivery-window]');
  var pickupInput = picker.querySelector('[data-pickup-input]');

  function chicagoNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  }
  function iso(d) {
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + day;
  }
  /* Special hours — Fri Oct 16, 2026 ONLY: open 8:00 PM – 11:30 PM (no pickup/delivery slots before 8 PM). */
  var SPECIAL_DATE = '2026-10-16';
  function hoursForDate(d) {
    if (iso(d) === SPECIAL_DATE) return [1200, 1410];
    return hoursFor(d.getDay());
  }
  function hoursFor(dow) {
    if (dow === 0 || dow === 5 || dow === 6) return [510, 1410]; // 8:30 AM - 11:30 PM
    if (dow === 2) return [510, 1350]; // 8:30 AM - 10:30 PM
    return [510, 1320]; // 8:30 AM - 10:00 PM
  }
  function earliest() {
    var now = chicagoNow();
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dow = d.getDay();
    var mins = now.getHours() * 60 + now.getMinutes();
    if (isNextDay) {
      d.setDate(d.getDate() + Math.max(leadDays, 1));
      if (dow === 6 && mins >= 600) d.setDate(d.getDate() + 1); // Sat after 10 AM → skip a day (warehouse closed Sun)
    } else {
      var hrs = hoursFor(dow);
      if (mins + prepMin >= hrs[1]) d.setDate(d.getDate() + 1);
    }
    return d;
  }
  function pretty(d) {
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'America/Chicago' });
  }

  var min = earliest();
  dateInput.min = iso(min);
  var max = new Date(min.getFullYear(), min.getMonth(), min.getDate());
  max.setDate(max.getDate() + 60);
  dateInput.max = iso(max);
  dateInput.value = iso(min);

  /* ---- Delivery windows (2-hour, day-dependent last slot) ---- */
  var WINDOWS_MT = ['9:00 AM – 11:00 AM','11:00 AM – 1:00 PM','1:00 PM – 3:00 PM','3:00 PM – 5:00 PM','5:00 PM – 7:00 PM','7:00 PM – 9:00 PM','9:00 PM – 10:00 PM'];
  var WINDOWS_FSU = ['9:00 AM – 11:00 AM','11:00 AM – 1:00 PM','1:00 PM – 3:00 PM','3:00 PM – 5:00 PM','5:00 PM – 7:00 PM','7:00 PM – 9:00 PM','9:00 PM – 11:30 PM'];
  function updateDeliveryWindows() {
    if (!deliverySelect || !dateInput.value) return;
    var prevVal = deliverySelect.value; // 5: preserve selection if still valid
    var parts = dateInput.value.split('-');
    var d = new Date(parseInt(parts[0],10), parseInt(parts[1],10)-1, parseInt(parts[2],10));
    var dow = d.getDay();
    var wins = (dow === 5 || dow === 6 || dow === 0) ? WINDOWS_FSU : WINDOWS_MT;
    if (dateInput.value === SPECIAL_DATE) wins = ['8:00 PM – 10:00 PM', '9:00 PM – 11:30 PM'];
    // Filter out past windows if date is today
    var now = chicagoNow();
    var todayS = iso(now);
    var nowMins = now.getHours() * 60 + now.getMinutes();
    // Window end times in minutes (for filtering — window valid if there's still time left)
    var winEnds = {
      '9:00 AM – 11:00 AM': 660, '11:00 AM – 1:00 PM': 780, '1:00 PM – 3:00 PM': 900,
      '3:00 PM – 5:00 PM': 1020, '5:00 PM – 7:00 PM': 1140, '7:00 PM – 9:00 PM': 1260,
      '8:00 PM – 10:00 PM': 1320, '9:00 PM – 10:00 PM': 1320, '9:00 PM – 11:30 PM': 1410
    };
    deliverySelect.innerHTML = '<option value="">Select a window…</option>';
    wins.forEach(function(w) {
      // Skip windows that end before (now + prep) — no time left to deliver
      if (dateInput.value === todayS) {
        var we = winEnds[w] || 0;
        if (we < nowMins + prepMin) return;
      }
      var o = document.createElement('option');
      o.value = w; o.textContent = w;
      deliverySelect.appendChild(o);
    });
    // 5: restore previous selection if still valid for new date
    if (prevVal) {
      var stillValid = Array.prototype.some.call(deliverySelect.options, function(opt) { return opt.value === prevVal; });
      if (stillValid) deliverySelect.value = prevVal;
    }
  }

  /* ---- Pickup wheel (hour + 10-min + AM/PM) ---- */
  var hourCol = picker.querySelector('[data-pwp-hour]');
  var minCol = picker.querySelector('[data-pwp-min]');
  var ampmCol = picker.querySelector('[data-pwp-ampm]');
  var wheelAp = null;        // meridiem the hour column currently shows
  var wheelHoursByAp = null; // {AM:[...], PM:[...]} from the last buildWheel
  function syncHourColToAp() {
    if (!ampmCol || !hourCol || !wheelHoursByAp) return;
    var apNow = readCol(ampmCol);
    if (!apNow || apNow === wheelAp) return;
    var list = wheelHoursByAp[apNow] || [];
    if (!list.length) return;
    wheelAp = apNow;
    var curH = readCol(hourCol);
    buildCol(hourCol, list, list.indexOf(curH) >= 0 ? curH : list[0]);
  }

  function buildCol(col, items, selected) {
    if (!col) return;
    col.innerHTML = '';
    // Top padding for wheel effect
    var padTop = document.createElement('div');
    padTop.className = 'pwp-pad';
    col.appendChild(padTop);
    items.forEach(function(it) {
      var d = document.createElement('div');
      d.className = 'pwp-item';
      d.textContent = it;
      d.dataset.val = it;
      // Tap-to-select: clicking an item scrolls it to center (mobile-friendly)
      d.addEventListener('click', function() {
        col.scrollTo({ top: d.offsetTop - col.offsetHeight/2 + d.offsetHeight/2, behavior: 'smooth' });
        setTimeout(function() { markSel(col); }, 350);
      });
      col.appendChild(d);
    });
    // Bottom padding for wheel effect
    var padBot = document.createElement('div');
    padBot.className = 'pwp-pad';
    col.appendChild(padBot);
    // Center the selected item
    setTimeout(function() {
      var idx = items.indexOf(selected);
      if (idx >= 0 && col.children[idx + 1]) {
        col.scrollTop = col.children[idx + 1].offsetTop - col.offsetHeight/2 + 22;
      }
      markSel(col);
    }, 50);
    setTimeout(function() {
      var idx2 = items.indexOf(selected);
      if (idx2 >= 0 && col.children[idx2 + 1]) {
        col.scrollTop = col.children[idx2 + 1].offsetTop - col.offsetHeight/2 + 22;
      }
      markSel(col);
    }, 350);
  }
  function readCol(col) {
    if (!col) return '';
    var items = col.querySelectorAll('.pwp-item');
    var center = col.scrollTop + col.offsetHeight/2;
    var best = null, bestDist = 1e9;
    items.forEach(function(it) {
      var c = it.offsetTop + it.offsetHeight/2;
      var dist = Math.abs(c - center);
      if (dist < bestDist) { bestDist = dist; best = it; }
    });
    return best ? best.dataset.val : '';
  }

  function markSel(col) {
    if (!col) return;
    var items = col.querySelectorAll('.pwp-item');
    var center = col.scrollTop + col.offsetHeight/2;
    var best = null, bestDist = 1e9;
    items.forEach(function(it) {
      var c = it.offsetTop + it.offsetHeight/2;
      var dist = Math.abs(c - center);
      if (dist < bestDist) { bestDist = dist; best = it; }
    });
    items.forEach(function(it) { it.classList.toggle('is-sel', it === best); });
  }
  function markAllSel() { markSel(hourCol); markSel(minCol); markSel(ampmCol); }
  function updatePickupInput() {
    if (!pickupInput) return;
    var h = readCol(hourCol), m = readCol(minCol), ap = readCol(ampmCol);
    if (h && m && ap) {
      var h24 = parseInt(h, 10);
      if (ap === 'PM' && h24 !== 12) h24 += 12;
      if (ap === 'AM' && h24 === 12) h24 = 0;
      var selMins = h24 * 60 + parseInt(m, 10);
      // Validate: not in the past if date is today
      var now = chicagoNow();
      var todayS = iso(now);
      if (dateInput.value === todayS) {
        var nowMins = now.getHours() * 60 + now.getMinutes();
        if (selMins < nowMins + prepMin) {
          // Selected time is in the past or too soon — reset to first valid
          buildWheel();
          return;
        }
      }
      // m1: validate against closing time for the selected date
      var selParts = dateInput.value ? dateInput.value.split('-') : null;
      if (selParts) {
        var selDate = new Date(parseInt(selParts[0],10), parseInt(selParts[1],10)-1, parseInt(selParts[2],10));
        var selHrs = hoursForDate(selDate);
        if (selMins > selHrs[1] || selMins < selHrs[0]) {
          // After closing or before opening — reset to first valid
          buildWheel();
          return;
        }
      }
      pickupInput.value = h + ':' + m + ' ' + ap;
    }
  }
  function buildWheel() {
    var mins = ['00','10','20','30','40','50'];
    var ampms = ['AM','PM'];
    var now = chicagoNow();
    var todayS = iso(now);

    // Get business hours for the SELECTED date
    var selParts = dateInput.value ? dateInput.value.split('-') : null;
    var selDate = selParts ? new Date(parseInt(selParts[0],10), parseInt(selParts[1],10)-1, parseInt(selParts[2],10)) : now;
    var selDow = selDate.getDay();
    var hrs = hoursForDate(selDate); // [open, close] in minutes
    var openHr = Math.floor(hrs[0] / 60); // 8 (8:30 AM → start at 9)
    var closeHr = Math.floor(hrs[1] / 60); // 22, 22, or 23

    // Pickup starts at 9 AM (10 AM for ready-nextday)
    var startHr = isNextDay ? 10 : 9;
    if (openHr > startHr) startHr = openHr;

    // Build valid hours list (24h format for logic, 12h for display)
    // 4: hour included if its :00 slot is at/before closing (minutes validated per-selection)
    // AND at least one slot in the hour must be after (now + prep)
    var validHours = [];
    var cutoffMins = null;
    if (dateInput.value === todayS) {
      var nowMins2 = now.getHours() * 60 + now.getMinutes();
      cutoffMins = nowMins2 + prepMin;
    }
    for (var h = startHr; h <= closeHr; h++) {
      // m1: include hour if its :00 slot fits (was: required :50 to fit, dropping 11 PM hour)
      if (h * 60 > hrs[1]) continue;
      // Skip hour if even its latest slot is before the cutoff (too soon)
      var latestSlotMins = h * 60 + 50;
      if (cutoffMins !== null && latestSlotMins < cutoffMins) continue;
      validHours.push(h);
    }
    // Fallback: if no valid hours today, move date to tomorrow
    if (!validHours.length && dateInput.value === todayS) {
      var tomorrow = new Date(selDate.getFullYear(), selDate.getMonth(), selDate.getDate() + 1);
      // M7-A: Saturday after 10 AM → skip Sunday ONLY for next-day (warehouse closed)
      if (isNextDay && selDow === 6) {
        var nowHrs = now.getHours() * 60 + now.getMinutes();
        if (nowHrs >= 600) tomorrow.setDate(tomorrow.getDate() + 1);
      }
      dateInput.value = iso(tomorrow);
      if (hint) hint.textContent = 'No more pickups today — earliest: ' + pretty(tomorrow) + '.';
      // Rebuild with tomorrow's hours
      selDate = tomorrow;
      selDow = selDate.getDay();
      hrs = hoursForDate(selDate);
      openHr = Math.floor(hrs[0] / 60);
      closeHr = Math.floor(hrs[1] / 60);
      startHr = isNextDay ? 10 : 9;
      if (openHr > startHr) startHr = openHr;
      for (var h3 = startHr; h3 <= closeHr; h3++) {
        if (h3 * 60 + 50 <= hrs[1]) validHours.push(h3);
      }
    }

    // Convert to 12h display, split by AM/PM
    function to12(h) {
      if (h === 0) return ['12','AM'];
      if (h < 12) return [String(h),'AM'];
      if (h === 12) return ['12','PM'];
      return [String(h - 12),'PM'];
    }
    var defH = '9', defM = '00', defAp = 'AM';
    // Default to first valid hour
    if (validHours.length) {
      var dh = to12(validHours[0]);
      defH = dh[0]; defAp = dh[1];
    }

    var hoursAM = [], hoursPM = [];
    validHours.forEach(function(h) {
      var t = to12(h);
      if (t[1] === 'AM') hoursAM.push(t[0]);
      else hoursPM.push(t[0]);
    });
    // Remove duplicates (e.g., 12 appears once)
    hoursAM = [...new Set(hoursAM)];
    hoursPM = [...new Set(hoursPM)];

    var hours = (defAp === 'AM') ? hoursAM : hoursPM;
    if (!hours.length) hours = hoursAM.length ? hoursAM : hoursPM;
    wheelAp = (hours === hoursPM) ? 'PM' : 'AM';
    wheelHoursByAp = { AM: hoursAM, PM: hoursPM };

    buildCol(hourCol, hours, defH);
    buildCol(minCol, mins, defM);
    buildCol(ampmCol, ampms, defAp);
    // Set default to first VALID time, not just first hour
    // Find the first valid minute for the default hour
    var defMins = '00';
    if (cutoffMins !== null) {
      var dh24 = parseInt(defH, 10);
      if (defAp === 'PM' && dh24 !== 12) dh24 += 12;
      if (defAp === 'AM' && dh24 === 12) dh24 = 0;
      // Find first minute >= cutoff
      for (var mi = 0; mi < mins.length; mi++) {
        var testMins = dh24 * 60 + parseInt(mins[mi], 10);
        if (testMins >= cutoffMins && testMins <= hrs[1]) {
          defM = mins[mi];
          break;
        }
      }
      // Rebuild minute column with correct default selected
      buildCol(minCol, mins, defM);
    }
    if (pickupInput) pickupInput.value = defH + ':' + defM + ' ' + defAp;
    // Note: AM/PM hour filtering removed — was causing infinite rebuild loop ("tweaking").
    // Hours are pre-filtered on build based on business hours.
  }
  [hourCol, minCol, ampmCol].forEach(function(col) {
    if (col) col.addEventListener('scroll', function() {
      clearTimeout(col._t);
      col._t = setTimeout(function() { syncHourColToAp(); markAllSel(); updatePickupInput(); }, 150);
    });
  });

  /* ---- Show/hide based on Pickup/Delivery choice ---- */
  function updateMethodUI() {
    var checked = document.querySelector('[data-fulfillment-choice]:checked');
    var method = checked ? checked.value : '';
    // Unlock date/time only after they pick pickup or delivery
    if (dateInput.hasAttribute('data-fulfill-date-disabled')) {
      if (method) {
        dateInput.removeAttribute('disabled');
        dateInput.removeAttribute('data-fulfill-date-disabled');
      }
    }
    if (pickupWrap) pickupWrap.hidden = (method !== 'Pickup');
    if (deliveryWrap) deliveryWrap.hidden = (method !== 'Delivery');
    // X1-A: clear AND disable the non-selected time input so stale values don't submit
    // 4: disabled inputs are excluded from FormData (no empty-string props)
    var pickupInput = document.querySelector('[data-pickup-input]');
    var windowSelect = document.querySelector('[data-delivery-window]');
    if (method === 'Pickup') {
      if (windowSelect) { windowSelect.value = ''; windowSelect.disabled = true; }
      if (pickupInput) pickupInput.disabled = false;
    } else if (method === 'Delivery') {
      if (pickupInput) { pickupInput.value = ''; pickupInput.disabled = true; }
      if (windowSelect) windowSelect.disabled = false;
    } else {
      if (pickupInput) pickupInput.disabled = true;
      if (windowSelect) windowSelect.disabled = true;
    }
    if (method === 'Pickup' && hourCol && !hourCol.children.length) buildWheel();
    if (method === 'Delivery') updateDeliveryWindows();
  }
  document.querySelectorAll('[data-fulfillment-choice]').forEach(function(r) {
    r.addEventListener('change', updateMethodUI);
  });

  /* ---- Date change ---- */
  function updateHint() {
    var parts = dateInput.value.split('-');
    var sel = new Date(parseInt(parts[0],10), parseInt(parts[1],10)-1, parseInt(parts[2],10));
    if (dateInput.value < iso(min)) {
      dateInput.value = iso(min);
      sel = new Date(min.getFullYear(), min.getMonth(), min.getDate());
      if (hint) hint.textContent = 'Earliest available: ' + pretty(sel) + ' — earlier dates not available.';
    } else if (hint) {
      hint.textContent = 'Earliest available: ' + pretty(sel) + '.';
    }
    updateDeliveryWindows();
    // M6-A: rebuild wheel on date change for correct business hours
  }
  dateInput.addEventListener('change', function() {
    updateHint();
    var hourCol = document.querySelector('[data-pwp-hour]');
    var minCol = document.querySelector('[data-pwp-min]');
    var ampmCol = document.querySelector('[data-pwp-ampm]');
    if (hourCol) hourCol.innerHTML = '';
    if (minCol) minCol.innerHTML = '';
    if (ampmCol) ampmCol.innerHTML = '';
    var checked = document.querySelector('[data-fulfillment-choice]:checked');
    if (checked && checked.value === 'Pickup') buildWheel();
  });
  updateHint();
  updateMethodUI();
})();
